import { Outlet } from 'react-router-dom';

import PageContainer from '~/shared/components/PageContainer';

import KPICards from './KPICards';
import NavTabs from './NavTabs';

export default function FleetManagerPage() {
  const tabs = [
    { label: 'AutoScale Rules', to: 'autoscale-rules' },
    { label: 'All Volumes', to: 'all-volumes' },
  ];

  return (
    <PageContainer className="px-[30px] pb-4! min-w-[1120px] w-full flex-1!">
      <div>
        <KPICards />
      </div>

      <div className="mt-3">
        <NavTabs items={tabs} className="" />
      </div>

      <div className="mt4  flex-1">
        <Outlet />
      </div>
    </PageContainer>
  );
}
